import { SELECTOR, setSelector } from '@socialive/common';

const selectPreferences = (state) => state.preferences;

setSelector(SELECTOR.PREFERENCES, selectPreferences);

export default selectPreferences;
